var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddThin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard17",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-15",
    stroke: "#74797D",
    x: 0.5,
    y: 0.5,
    width: 16,
    height: 16,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-16",
    fill: "#74797D",
    x: 4,
    y: 8,
    width: 9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-17",
    fill: "#74797D",
    x: 8,
    y: 4,
    width: 1,
    height: 9
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddThin);
export default __webpack_public_path__ + "static/media/add-thin.a984fc51ad11f497613a26d15aeab5d6.svg";
export { ForwardRef as ReactComponent };